import React from "react"
import Helmet from "react-helmet"
import { graphql } from "gatsby"
import Layout from "../components/layout"

const AboutPage = ({
  data: {
    site,
  },
}) => (
  <Layout>
    <Helmet>
      <title>このブログについて | {site.siteMetadata.title}</title>
      <meta name="description" content="KenRp Blogについて。開発メモ、学習ログ、技術実験を残す個人ブログです。" />
    </Helmet>
    <section className="page-header">
      <p className="eyebrow">About</p>
      <h1>KenRp Blog</h1>
      <p>
        開発メモ、学習ログ、小さな技術実験を残していく個人ブログです。
      </p>
    </section>
    <section className="two-grids blog-section">
      <div>
        <h2>書くテーマ</h2>
        <p>
          アプリケーション開発、JavaScript、API、デプロイ、ツール検証など、実際に手を動かして得た知見を中心にまとめます。
        </p>
      </div>
      <div>
        <h2>書き方</h2>
        <p>
          長い解説よりも、あとで見返せる短いメモ、再現できる手順、実装時に気づいたポイントを大事にします。
        </p>
      </div>
    </section>
  </Layout>
)

export default AboutPage

export const pageQuery = graphql`
  query AboutPageQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`
